import React, { useState } from 'react';
import { FormTitle, FormDescription } from "./FieldLabel";
import { usePageTour } from "../Common/usePageTour";
import useStyle from '../../hooks/useStyle';
import { usePageLocale } from '../../hooks/useLocale';
import { FormRuleAlertIcon } from "./FormRuleAlert";
import { HelpIcon } from "../Help/HelpSidePanel";
import { useCurrentUserHook } from '../Authentication/useUserHook';

const FormContainer = (props) => {
  useStyle('/css/form.css', true);

  let { post, titleTag, formId, locale } = props;
  const tour = usePageTour();
  const [hideForm, setHideForm] = useState(false);
  const { currentUser } = useCurrentUserHook();
  const langauge = locale || currentUser?.current_locale;
  const { labelLocale } = usePageLocale(langauge, 'formLocale');

  try {
    formId = props?.children[0]?.props?.formId;
  } catch (e) {
    console.log(e.message);
  }

  /*props.formFn.hideForm = () =>{
    setHideForm(true)
  }

  props.formFn.showForm = () =>{
    setHideForm(false)
  }*/

  const openPageTour = () => {
    try {
      /*template.template_fields[activeKey].child_template_fields.forEach((f)=>{
        setPageTour(
          `form_${template.id}`,
          {id:f.client_id, title:f.label, description:f.label}
        )   
      })*/
      tour && tour.init(true, 'form_tour')
    } catch (e) {
      console.log(e.message)
    }
  }

  /*if(hideForm) return null;*/

  return (
    <section id="ct">
      <div className={props.isPopupMode ? 'form p-0 m-t-0' : 'form app-content m-t-30 m-t-20-xs'}>
        <div className="flex justspacebetween modal-title aligncenter">
          <h4 className="f18 f16-xss text-white fw500 p20 p15-xs p10-xss">
            <FormTitle title={post.title} locale={post.locale_title} currentLocale={langauge} />
            {titleTag ? <span className="m-l-5"> - {titleTag}</span> : null}
          </h4>
          <HelpIcon recordIds={post.help_id} className={`m-r-15 font-18 ${props.isPopupMode ? 'm-t-25' : ''}`} />
        </div>
        <div className="tab-details">
          <div className="form-details">
            <FormDescription details={post.details} locale={post.locale_details} currentLocale={langauge} />
          </div>
          <p>
            <span className="text-red m-r-10">*</span>
            <span className="text-gray">{labelLocale(1)}</span>
          </p>
          <div className="flex rowrev">
            <FormRuleAlertIcon currentUser={currentUser} formId={formId} />
          </div>
        </div>
        {props.children}
      </div>
    </section>
  )
}

export default FormContainer;